<template>
  <div class="lineup bg-color-dark">
    <vue-headful :title="doctitle" />
    <div v-if="this.status != 'sessions'" class="container tags-container">
      <h1 class="big-headline pt-5 text-color-light">
        Pick their brains. Gain their knowledge
      </h1>
      <h5 class="text-color-light">Pick your areas of interest below</h5>
      <div v-if="loadtags" class="row justify-content-center loading-tags">
        <c-spinner></c-spinner>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-12 text-right select-all">
            <a
              v-if="this.tags.length !== this.tagschoosen.length"
              href="#"
              v-on:click="selectAllTags()"
            >
              Select all
            </a>
            <span
              v-if="
                this.tagschoosen.length > 0 &&
                this.tags.length !== this.tagschoosen.length
              "
            >
              |
            </span>
            <a
              v-if="this.tagschoosen.length > 0"
              href="#"
              v-on:click="deselectAllTags()"
            >
              Deselect all
            </a>
          </div>
          <div class="tags row col-12">
            <div
              class="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-xs-6"
              v-for="tag in tags"
              :key="tag.index"
            >
              <div
                v-on:click="setTag(tag)"
                v-bind:class="[setActiveTag(tag)]"
                class="tag text-center text-color-light"
              >
                {{ tag.org }}
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center pb-5">
          <button
            v-on:click="setStatus('sessions')"
            v-bind:class="[setActiveNext()]"
            class="btn btn-1"
          >
            <i class="material-icons">done</i>
          </button>
        </div>
      </div>
    </div>

    <!---------------------------- SESSIONS --------------------------------------->

    <div v-if="this.status === 'sessions'">
      <div class="background">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="text-color-dark big-headline mt-5">
                This year's speakers
              </h1>
            </div>
          </div>
          <div class="row mt-5 mb-5">
            <div class="col-12 col-lg-8 tags-choosen">
              <div
                class="tags-add text-center"
                @click="selectAllTags()"
                :class="
                  tagschoosen.length === tags.length ? 'disabled-all' : ''
                "
              >
                <small>All</small>
              </div>
              <div
                class="tags-add text-center pl-0 pr-0"
                :class="tagschoosen.length === 0 ? 'disabled-all' : ''"
                href="#"
                v-on:click="deselectAllTags()"
              >
                <small>Clear</small>
              </div>
              <!--         <div
                class="tags-add text-center pl-0 pr-0"
                href="#"
                @click="setStatus('tags')"
              >
                <i class="material-icons">filter_alt</i>
              </div> -->
              <!--  <div v-on:click="setStatus('tags')" class="tags-add text-center">
                <i class="material-icons">add</i>
              </div> -->

              <!--    <div class="dropdown d-inline">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="material-icons">filter_1</i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <h6 class="dropdown-header">Give me one track only!</h6>

                  <a
                    class="dropdown-item"
                    href="#"
                    style="text-decoration: none !important"
                    @click="setTag(tag)"
                    :class="[setActiveTag(tag)]"
                    v-for="tag in tags"
                    :key="tag.index"
                    >{{ tag.org }}</a
                  >
                </div>
              </div> -->

              <div class="tags d-flex flex-wrap">
                <div
                  class="tag-choosen text-center"
                  v-for="tag in tags"
                  :key="tag.index"
                  @click="setTag(tag)"
                  v-bind:class="[setActiveTag(tag)]"
                >
                  <span>{{ tag.org }} </span>
                </div>
              </div>

              <!--   <div
                v-for="tag in tagschoosen"
                class="tag-choosen text-center active"
                :key="tag.index"
                style="cursor: default"
              >
                <span>{{ tag.org }}</span>
                <i
                  @click="setTag(tag)"
                  class="material-icons pr-2 pl-2"
                  style="cursor: pointer"
                  >clear</i
                >
              </div> -->
              <div
                v-if="this.speakername"
                v-on:click="resetSpeaker()"
                class="tag-choosen text-center active speaker"
              >
                <span v-if="loadspeakername"> &nbsp; </span>
                <span v-else>
                  {{ this.speaker.speakerFirstName }}
                  {{ this.speaker.speakerLastName }}
                </span>

                <i class="material-icons">clear</i>
              </div>
            </div>
            <div class="col-12 col-lg-2">
              <img
                src="https://res.cloudinary.com/oredev/image/upload/v1684917754/ezgif.com-optimize.gif"
                class="fluid space-man"
                alt="space-man"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="container pt-4">
        <div
          v-if="this.speakername"
          class="speaker-single bg-green pb-3 pr-3 pl-3"
        >
          <b-row no-gutters class="mt-5 justify-content-md-center">
            <div class="col-md-4 col-sm-12 text-center">
              <div id="scroll-anchor"></div>

              <div v-if="!this.loadspeakername">
                <img
                  class="mb-4 speaker-image"
                  v-if="speaker.speakerImagePuId"
                  :key="myKey"
                  v-bind:src="
                    'https://res.cloudinary.com/oredev/image/upload/' +
                    'g_face,r_max,c_thumb,w_320,h_320,e_grayscale,b_rgb:69AFAB/' +
                    speaker.speakerImageVersion +
                    '/' +
                    speaker.speakerImagePuId
                  "
                  alt=""
                />
              </div>

              <div v-else>
                <c-spinner></c-spinner>
              </div>
            </div>

            <div class="col-md-8 col-sm-12">
              <div class="p-3 pb-4 5 bg-green text-color-dark mt-3">
                <h4 class="text-color-dark pb-2 speaker-name">
                  {{ this.speaker.speakerFirstName }}
                  {{ this.speaker.speakerLastName }}
                </h4>
                <a
                  v-if="speaker.speakerTwitter"
                  class="mb-2 d-block"
                  style="
                    cursor: pointer;
                    text-decoration: none !important;
                    color: #292929 !important;
                  "
                  :href="'http://twitter.com/' + speaker.speakerTwitter"
                >
                  {{ speaker.speakerTwitter }}
                </a>

                <p class="text-left">
                  {{ speaker.speakerBiography }}
                </p>
              </div>
            </div>
          </b-row>

          <div
            v-for="session in this.speaker.speakerSession"
            v-bind:class="[setActiveSchedule(session.sId)]"
            class="row session"
            :key="session.index"
          >
            <div class="col-lg-9 col-8 main speaker-bg">
              <div class="row">
                <div class="col-6 speaker">
                  {{ getDay(session.scheduleDay) }} {{ session.scheduleTime }}
                </div>
                <div
                  v-on:click="toggleText(session.sId)"
                  class="col-12 session-info pb-3"
                >
                  <h5>
                    <span class="fold-icons"
                      ><i
                        :data-id="session.sId"
                        class="material-icons hidden align-middle"
                        >unfold_less</i
                      ><i
                        :data-id="session.sId"
                        class="material-icons align-middle"
                        >unfold_more</i
                      ></span
                    >
                    <span class="session-title pink">{{ session.title }}</span>
                  </h5>
                </div>
              </div>
              <div :data-id="session.sId" class="col-12 session-text hidden">
                <h6>Key takeaways</h6>
                <ul>
                  <li v-if="session.takeAway1">{{ session.takeAway1 }}</li>
                  <li v-if="session.takeAway2">{{ session.takeAway2 }}</li>
                  <li v-if="session.takeAway3">{{ session.takeAway3 }}</li>
                  <li v-if="session.takeAway4">{{ session.takeAway4 }}</li>
                </ul>
                <p>
                  {{ session.description }}
                </p>
                <div class="open-in-new">
                  <a
                    target="_blank"
                    v-if="session.url"
                    v-bind:href="'/sessions/' + session.url"
                  >
                    <i class="material-icons">open_in_new</i>
                  </a>
                </div>
              </div>
            </div>
            <div
              class="col-lg-3 col-4 add-schedule speaker-bg"
              v-on:click="setSchedule(session.sId, $event)"
            >
              <b-button
                class="btn btn-1 add mt-3 float-right"
                :class="setActiveSchedule(session.sId, true)"
                >{{ addOrRemove(session.sId) }}</b-button
              >
              <!-- <i class="material-icons h2 align-middle add green"
                >add_circle_outline</i
              >
              <i class="material-icons h2 align-middle remove pink"
                >remove_circle_outline</i
              > -->
            </div>
          </div>
        </div>
        <pre>{{ tagschoosen.length }}</pre>
        <div v-if="tagschoosen.length == 0" class="pt-3 pb-5">
          <b-row>
            <b-col cols="12">
              <h6 class="text-color-light text-center">
                Game over, select tracks to see speakers
                <a @click="selectAllTags()" href="#" rel="noopener noreferrer"
                  >(show all)</a
                >
              </h6>
              <div class="d-flex align-items-center justify-content-center">
                <img
                  style="max-width: 50%; cursor: pointer"
                  src="https://res.cloudinary.com/oredev/image/upload/v1680286129/2023_web/Start-over-animation.gif"
                  alt=""
                  @click="selectAllTags(), scrollToTop()"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-if="loadspeakers" class="row mt-5 justify-content-center">
          <c-spinner></c-spinner>
        </div>

        <div v-else class="row mt-5">
          <b-col
            cols="6"
            md="4"
            lg="3"
            v-bind:class="[setVisibleSpeakers(speaker.speakerSessionTags)]"
            class="speaker-card text-center mt-5"
            v-for="(speaker, index) in speakers"
            :key="index"
          >
            <div
              class="speaker-info pt-3 pb-3 pt-5 rounded d-flex flex-column justify-content-center"
            >
              <router-link
                v-bind:to="{
                  name: 'Lineup-single',
                  params: { name: speaker.speakerURL },
                  query: { tags: $route.query.tags },
                }"
                style="text-decoration: none !important"
              >
                <div class="d-flex justify-content-center">
                  <div
                    v-if="speaker.speakerImagePuId"
                    @mouseover="isHovering = speaker._id"
                    @mouseout="isHovering = ''"
                    :class="{ hovering: isHovering }"
                  >
                    <img
                      class="d-block speakerImage"
                      v-bind:src="
                        'https://res.cloudinary.com/oredev/image/upload/q_auto/g_face,r_max,c_thumb,w_220,h_220,b_rgb:292929,e_grayscale/v1/' +
                        speaker.speakerImagePuId
                      "
                      alt=""
                    />
                    <div class="glitch__layers">
                      <div
                        :class="
                          speaker._id === isHovering ? 'glitch__layer' : ''
                        "
                        :style="{
                          'background-image':
                            'url(' +
                            'https://res.cloudinary.com/oredev/image/upload/q_auto,e_grayscale/g_face,r_max,c_thumb,w_220,h_220,b_rgb:292929/v1/' +
                            speaker.speakerImagePuId +
                            ')',
                        }"
                      ></div>
                      <div
                        :class="
                          speaker._id === isHovering ? 'glitch__layer' : ''
                        "
                        :style="{
                          'background-image':
                            'url(' +
                            'https://res.cloudinary.com/oredev/image/upload/q_auto,e_grayscale/g_face,r_max,c_thumb,w_220,h_220,b_rgb:292929/v1/' +
                            speaker.speakerImagePuId +
                            ')',
                        }"
                      ></div>
                      <div
                        :class="
                          speaker._id === isHovering ? 'glitch__layer' : ''
                        "
                        :style="{
                          'background-image':
                            'url(' +
                            'https://res.cloudinary.com/oredev/image/upload/q_auto,e_grayscale/g_face,r_max,c_thumb,w_220,h_220,b_rgb:292929/v1/' +
                            speaker.speakerImagePuId +
                            ')',
                        }"
                      ></div>
                    </div>
                  </div>

                  <img
                    class="d-block speakerImage"
                    v-else
                    v-bind:src="'https://res.cloudinary.com/oredev/image/upload/e_grayscale/e_colorize:30,co_rgb:292929/g_face,r_max,c_thumb,w_220,h_220,b_rgb:292929/cfp/noimage'"
                    alt=""
                  />
                </div>
                <div>
                  <p
                    class="speaker-name text-center text-color-light"
                    style="overflow-wrap: break-word"
                  >
                    {{ speaker.speakerFirstName }} {{ speaker.speakerLastName }}
                  </p>
                </div>
              </router-link>
            </div>
          </b-col>
        </div>
      </div>
    </div>

    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-2"
      src="https://res.cloudinary.com/oredev/image/upload/v1683012353/2023_web/white-shape-2.png"
    />
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1679424058/2023_web/shapes%20lp/white-shape-5.png"
      class="d-none d-xl-block position-absolute"
      id="white-shape-3"
    />
    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-4"
      src="https://res.cloudinary.com/oredev/image/upload/v1680087567/2023_web/shapes%20info/white-shape-3.png"
      alt="rectangle"
    />

    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-6"
      src="https://res.cloudinary.com/oredev/image/upload/v1680088576/2023_web/shapes%20info/white-shape-6.png"
      alt="rectangle"
    />
    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-7"
      src="https://res.cloudinary.com/oredev/image/upload/v1680090042/2023_web/shapes%20info/white-shape-5.png"
      alt="rectangle"
    />
    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-8"
      src="https://res.cloudinary.com/oredev/image/upload/v1680089901/2023_web/shapes%20info/white-shape-7.png"
      alt="rectangle"
    />

    <img
      class="rectangle-long-1 position-absolute"
      src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
    />
    <img
      class="rectangle-long-2 d-none d-md-block position-absolute"
      src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
    />
    <img
      class="rectangle-green-short position-absolute"
      id="green-2"
      src="https://res.cloudinary.com/oredev/image/upload/v1679666601/2023_web/shapes%20info/Blue-shape-1.png"
      alt="rectangle"
    />
    <img
      class="rectangle-green-short position-absolute"
      id="green-3"
      src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
      alt="rectangle"
    />
    <img
      class="rectangle-green-short position-absolute"
      id="green-4"
      src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
      alt="rectangle"
    />
    <!-- here -->
    <img
      class="rectangle-orange position-absolute"
      id="orange-3"
      src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
    />
    <img
      class="rectangle-green-short position-absolute"
      id="green-5"
      src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
      alt="rectangle"
    />
    <img
      class="rectangle-orange position-absolute"
      id="orange-4"
      src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
    />
    <img
      class="rectangle-green-short position-absolute"
      id="green-6"
      src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
      alt="rectangle"
    />
  </div>
</template>

<script>
import { tagsMixin } from "../mixins/tagsMixin";
import Spinner from "./spinner/Spinner";

$(document).on("click", "someyourContainer .dropdown-menu", function (e) {
  console.log("%c 👊", "color: #007acc;", e);

  e.stopPropagation();
});

export default {
  name: "sessions",
  components: {
    "c-spinner": Spinner,
  },
  watch: {
    $route(to, from) {
      if (to.path != from.path) {
        $(".speaker-single").slideUp(200);
        this.loadspeakername = true;
        this.speakername = this.$route.params.name;
        this.getSpeaker();
      }
    },
  },
  data() {
    return {
      speakername: this.$route.params.name,
      speaker: {},
      speakers: [],
      schedule: [],
      day: "",
      loadspeakers: true,
      loadspeakername: true,
      doctitle: "",
      docimage: "",
      myKey: 0,
      isHovering: "",
    };
  },
  created() {
    this.getSpeaker();
  },
  mixins: [tagsMixin],
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getSpeaker: function () {
      if (this.speakername) {
        this.loadspeakername = true;

        this.axios
          .get("https://admin.oredev.org/plannedspeaker/" + this.speakername, {
            params: {
              //ID: 12345
            },
          })
          .then((response) => {
            const speaker = response.data.plannedspeakers;
            const speakersYear = speaker.filter((e) => {
              return e.conferencename === "Øredev 2023";
            });

            if (
              speakersYear.length &&
              speakersYear[0] &&
              speakersYear[0].speakerSession &&
              speakersYear[0].speakerSession.length
            ) {
              speakersYear[0].speakerSession.sort((a, b) => {
                const dayA = a.scheduleDay.toUpperCase(); // ignore upper and lowercase
                const dayB = b.scheduleDay.toUpperCase(); // ignore upper and lowercase
                if (dayA > dayB) {
                  return 1;
                }
                if (dayA < dayB) {
                  return -1;
                }

                // names must be equal
                return 0;
              });
            }

            this.speaker = speakersYear[0];

            if (
              this.speaker.speakerImagePuId ===
              "2022_speakers/erlend-oftedal-no"
            ) {
              this.speaker.speakerImageVersion = "";
              this.speaker.speakerImagePuId =
                this.speaker.speakerImagePuId + ".jpg";
            } else {
              this.speaker.speakerImageVersion =
                "v" + this.speaker.speakerImageVersion;
            }

            this.loadspeakername = false;
            this.myKey++;

            $(".speaker-single").slideDown(0);
            this.setDocTags();

            setTimeout(() => {
              $("#scroll-anchor").get(0).scrollIntoView({ behavior: "smooth" });
            }, 700);
            return;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    resetSpeaker: function () {
      $(".speaker-single").slideUp(200);
      this.loadspeakername = true;
      this.speaker = {};
      this.speakername = "";
      this.$router.push({
        path: "/line-up",
        params: { name: "" },
        query: { tags: this.$route.query.tags },
      });
      this.setDocTags();
    },
    setVisibleSpeakers: function (tags) {
      let show = false;
      let tagschoosen = this.tagschoosen;
      let containsTag = false;
      if (tagschoosen && tagschoosen.length) {
        if (tags && tags.length) {
          tags.forEach((tag) => {
            if (tagschoosen.some((element) => this.fixTag(element) === tag)) {
              containsTag = true;
            }
          });
        }
      }
      if (containsTag) {
        show = true;
      }
      if (show) {
        return "show";
      } else {
        return "hidden";
      }
    },
    /*     setActiveSchedule: function (id, isButton) {
      console.log("%c 👊", "color: #007acc;", id);
      console.log("%c 👊", "color: #007acc;", isButton);

      const selSchedule = this.schedule;

      let containsId = false;
      if (selSchedule) {
        containsId = selSchedule.some((element) => element === id);
      }
      if (containsId && isButton) {
        return "btn-active";
      }

      if (containsId) {
        return "active";
      }
    }, */
    fetchSpeakers: function () {
      let that = this;
      this.axios
        .get("https://admin.oredev.org/plannedspeakers/Øredev 2023", {
          params: {
            //ID: 12345
          },
        })
        .then((response) => {
          let speakers = response.data.plannedspeakers.map(function (speaker) {
            if (speaker.speakerSessionTags) {
              speaker.speakerSessionTags = speaker.speakerSessionTags.map(
                function (tag) {
                  tag = that.fixTag(tag);
                  return tag;
                }
              );
            }

            return speaker;
          });

          speakers = speakers.map((speaker) => {
            if (
              speaker.speakerImagePuId === "2022_speakers/erlend-oftedal-no"
            ) {
              speaker.speakerImagePuId = speaker.speakerImagePuId + ".jpg";
            }
            return speaker;
          });

          this.speakers = speakers;

          that.loadspeakers = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setStatusShowSpeaker: function () {
      if (this.tagschoosen.length === 0 && this.speakername) {
        this.status = "sessions";
      }
    },
    setDocTags: function () {
      this.doctitle = "Line up - " + this.$store.state.conferencename;
    },
  },
  updated: function () {},
  mounted: function () {
    this.status = localStorage.getItem("sessionstatus");
    this.day = localStorage.getItem("day");
    this.schedule = JSON.parse(localStorage.getItem("schedule"));
    this.setTagsChoosen();
    this.setStatusShowSpeaker();
    this.setDocTags();
  },
  beforeMount: function () {
    this.fetchSpeakers();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";

.session-title {
  font-family: "Verdana";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
}
.background {
  color: black;
  background: url("https://res.cloudinary.com/oredev/image/upload/v1684918134/2023_web/speaker-illustration-with-grain.jpg");
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
}

h2,
h3,
h4,
h5 {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

h2 {
  font-family: Verdana;
  font-size: 20px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
}

.svg-width {
  max-width: 150px;
}

.lineup .session .add-schedule i {
  @media (max-width: 767px) {
    margin-bottom: -10px;
  }
}

.open-in-new {
  text-align: right;
}

.speakerImage {
  margin-top: -90px;
}

@media screen and (max-width: 767px) {
  .speakerImage {
    margin-top: -130px;
    max-width: 120px;
  }
}

.speaker-biography {
  border: 1px solid deeppink;
  background-color: $purple;
  min-height: 260px;
}

.speaker-biography-focus {
  background-color: #e5e5e5;
  min-height: 260px;
  color: black;
}

.speaker-bg {
  background-color: #f2f2eb;
  color: black;
}

.bg-purple {
  background-color: $purple;
}

.overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.speaker-name {
  overflow: hidden;
  white-space: nowrap;

  text-overflow: ellipsis;
  display: inline;
  line-height: 20px;
  font-family: Verdana;
  font-size: 20px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

@keyframes move4 {
  0% {
    transform: translate(5px, 2px);
    animation-timing-function: ease-in-out;
  }

  25% {
    transform: translate(4px, 4px);
    animation-timing-function: ease-in-out;
  }

  50% {
    transform: translate(2px, 3px);
    animation-timing-function: ease-in-out;
  }

  75% {
    transform: translate(7px, 5px);
    animation-timing-function: ease-in-out;
  }

  100% {
    transform: translate(2px, 2px);
  }
}

.text-yellow {
  color: $yellow !important;
}

.speaker-name {
  margin-bottom: 5px;
  line-height: 1.5rem;
  overflow: inherit;
  white-space: inherit;
  display: block;
}

.speaker-image {
  border-radius: 200px;
  height: auto;
  max-width: 80%;
  margin-top: 30px;
  position: relative;
  z-index: 99;
}

.btn-1 {
  background-color: #f2f2eb !important;
}

.space-man {
  width: 520px;
}
@media (max-width: 1500px) {
  .space-man {
    max-width: 320px;
  }
}
@media (max-width: 767px) {
  .btn-1 {
    width: 90px !important;
  }
  .speaker-image {
    max-width: 50%;
  }
  .space-man {
    max-width: 100%;
  }
}

.rectangle-long-1 {
  width: 20%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  bottom: -196%;
  left: 0;
}
.rectangle-long-2 {
  width: 20%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  top: 100%;
  left: 0;
}

.rectangle-green-short,
.rectangle-orange {
  mix-blend-mode: color !important;
}
#green-2 {
  bottom: 50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 20%;
}
#green-3 {
  bottom: 29%;
  left: 0;
  max-width: 20%;
  z-index: 0;
}
#green-4 {
  bottom: 17.5%;
  max-width: 20%;
  z-index: 1;
  right: 0;
}
#green-5 {
  bottom: -80%;
  left: 0;
  max-width: 20%;
  z-index: 0;
}
#green-6 {
  bottom: -130%;
  max-width: 20%;
  z-index: 1;
  right: 0;
}
#orange-3 {
  bottom: -50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 20%;
}
#orange-4 {
  bottom: -110%;
  left: 0;
  width: 20%;
  height: 16px;
  z-index: 0;
}

#white-shape-1 {
  right: 30px;
  bottom: 65%;
}
#white-shape-2 {
  right: 35px;
  bottom: 71%;
}
#white-shape-2-mobile {
  right: 35px;
  bottom: 64%;
}
#white-shape-3 {
  right: 0;
  bottom: 37%;
  width: 16%;
}
#white-shape-4 {
  left: 3%;
  bottom: 37%;
}
#white-shape-5 {
  left: 3%;
  bottom: 7%;
  width: 17%;
}
#white-shape-6 {
  right: 3%;
  bottom: -22%;
}
#white-shape-7 {
  left: 3%;
  bottom: 5%;
}
#white-shape-8 {
  right: 3%;
  bottom: 13%;
}

.btn-active {
  background: $orange !important;
  color: white !important;
}

.glitch__layers {
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.glitch__layer {
  position: absolute;
  left: 33px;
  right: 0;
  top: 0;
  bottom: 0;
  background-repeat: no-repeat;
  background-position: 0 0;
}
.glitch__layer:nth-child(1) {
  transform: translateX(-0%);
  animation: glitch-anim-1 2s infinite linear alternate;
}
.glitch__layer:nth-child(2) {
  transform: translateX(0%) translateY(3%);
  animation: glitch-anim-2 2.3s -0.8s infinite linear alternate;
}
.glitch__layer:nth-child(3) {
  transform: translateX(0%);
  animation: glitch-anim-flash 1s infinite linear;
}
@keyframes glitch-anim-1 {
  0% {
    clip-path: polygon(0 0%, 100% 0%, 100% 5%, 0 5%);
  }
  10% {
    clip-path: polygon(0 15%, 100% 15%, 100% 15%, 0 15%);
  }
  20% {
    clip-path: polygon(0 10%, 100% 10%, 100% 20%, 0 20%);
  }
  30% {
    clip-path: polygon(0 1%, 100% 1%, 100% 2%, 0 2%);
  }
  40% {
    clip-path: polygon(0 35%, 100% 35%, 100% 35%, 0 35%);
  }
  50% {
    clip-path: polygon(0 45%, 100% 45%, 100% 46%, 0 46%);
  }
  60% {
    clip-path: polygon(0 50%, 100% 50%, 100% 70%, 0 70%);
  }
  70% {
    clip-path: polygon(0 70%, 100% 70%, 100% 70%, 0 70%);
  }
  80% {
    clip-path: polygon(0 80%, 100% 80%, 100% 80%, 0 80%);
  }
  90% {
    clip-path: polygon(0 50%, 100% 50%, 100% 55%, 0 55%);
  }
  100% {
    clip-path: polygon(0 60%, 100% 60%, 100% 70%, 0 70%);
  }
}
@keyframes glitch-anim-2 {
  0% {
    clip-path: polygon(0 15%, 100% 15%, 100% 30%, 0 30%);
  }
  15% {
    clip-path: polygon(0 3%, 100% 3%, 100% 3%, 0 3%);
  }
  25% {
    clip-path: polygon(0 8%, 100% 8%, 100% 20%, 0 20%);
  }
  30% {
    clip-path: polygon(0 20%, 100% 20%, 100% 20%, 0 20%);
  }
  45% {
    clip-path: polygon(0 45%, 100% 45%, 100% 45%, 0 45%);
  }
  50% {
    clip-path: polygon(0 50%, 100% 50%, 100% 57%, 0 57%);
  }
  65% {
    clip-path: polygon(0 60%, 100% 60%, 100% 60%, 0 60%);
  }
  75% {
    clip-path: polygon(0 80%, 100% 80%, 100% 80%, 0 80%);
  }
  80% {
    clip-path: polygon(0 40%, 100% 40%, 100% 60%, 0 60%);
  }
  95% {
    clip-path: polygon(0 45%, 100% 45%, 100% 60%, 0 60%);
  }
  100% {
    clip-path: polygon(0 11%, 100% 11%, 100% 15%, 0 15%);
  }
}
@keyframes glitch-anim-flash {
  0% {
    opacity: 0.2;
  }
  30%,
  100% {
    opacity: 0;
  }
}

.btn-1:hover {
  background: $orange !important;
  color: white !important;
}

.btn {
  display: inline-block;
  border: 1px solid rgba(0, 128, 0, 0) !important;
  width: 44px;
  height: 44px;
  margin-bottom: 3px;
  padding: 10px;
  background-color: $green !important;
  color: #fff !important;
  cursor: pointer;
}

.dropdown-toggle::after {
  border-top: 0 !important;
}

.dropdown-menu {
  background-color: $bg-dark;
}
.dropdown-menu a {
  color: $text-color-light !important;
}
.dropdown-menu a:hover {
  color: $text-dark !important;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: #69afab !important;
}
.dropdown-item.active:hover {
  color: $text-color-light !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Lineup.vue